import { inject, Injectable } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ThemeService } from './theme.service';

@Injectable({
  providedIn: 'root'
})


export class FullScreenDialogService extends NgbModal {
  private currentModal: NgbModalRef | null = null

  private themeService = inject(ThemeService)

  constructor() {
    super()
    window.addEventListener('popstate', () => {
      if (this.currentModal) {
        this.currentModal.close();
        this.currentModal = null;
      }
    })
  }

  override open(content: any, options: any = {}) {
    if (!window.location.href.includes('#modal')) {
      window.history.pushState(null, '', window.location.href + '#modal')
    }
    document.documentElement.setAttribute('data-bs-theme', 'light')
    this, this.currentModal = super.open(content, options)
    this.currentModal.result.finally(() => {
      if (this.currentModal) {
        this.currentModal = null
        window.history.back()
      }
      this.themeService.setTheme(this.themeService.storedTheme)
    })
    return this.currentModal
  }
}
